import {createContext} from 'react';

export interface ErrorInformerPushContextValue {
	push(error: unknown): void;
}

export const ErrorInformerPushContext = createContext<ErrorInformerPushContextValue | null>(null);

ErrorInformerPushContext.displayName = 'ErrorInformerPushContext';
